import "./components/jquery";

import tns from "@story/story_vendor/tiny_slider/tiny_slider";
import "@story/story_vendor/ajax_form/ajax_form";
import { installLegacyTurnstile } from "@story/story_assets/turnstile_legacy";
import "@story/story_vendor/fancybox3/fancybox";
import "@story/story_vendor/air_datepicker/air_datepicker";

import "./components/scroll";
import "./components/date_picker";
import "./components/tabs";

installLegacyTurnstile(window.jQuery);

$(document).ready(function () {

	// *************************************************************************
	// Mobile menu
	// *************************************************************************

	var $pageHamburger = $(".page-hamburger");
	var $pageHeader = $(".page-header");
	var $pageNav = $(".page-navigation");
	var $body = $("body");

	function showMobileMenu() {
		$pageHamburger.addClass("active");
		$pageHeader.addClass("active");
		$pageNav.fadeIn();
		$body.addClass("no-scroll");
	}

	function hideMobileMenu() {
		$pageHamburger.removeClass("active");
		$pageHeader.removeClass("active");
		$pageNav.fadeOut();
		$body.removeClass("no-scroll");
	}

	$(".page-hamburger").click(function () {
		if ($pageHamburger.hasClass("active")) {
			hideMobileMenu();
		}
		else {
			showMobileMenu();
		}
	});


	// *************************************************************************
	// AJAX forms
	// *************************************************************************

	$.ajaxForm();

	// *************************************************************************
	// Homepage intro slider
	// *************************************************************************

	if ($(".homepage-intros-carousel").length) {
		var slider = tns({
			container: ".homepage-intros-carousel",
			mode: "gallery",
			autoplay: true,
			speed: 1000,
			autoplayTimeout: 5000,
			items: 1,
			controlsPosition: "bottom",
			navPosition: "bottom",
			autoplayButtonOutput: false,
			controlsText: ["<span class='fas fa-angle-left'></span>", "<span class='fas fa-angle-right'></span>"]
		});

		if (slider) {
			slider.getInfo().prevButton.classList.add("tns-prev-button");
			slider.getInfo().nextButton.classList.add("tns-next-button");
			$(slider.getInfo().navContainer).wrap("<div class='tns-nav-wrapper'></div>");
		}
	}


	// *************************************************************************
	// Homepage news slider
	// *************************************************************************

	if ($(".homepage-news-carousel").length) {
		var slider = tns({
			container: ".homepage-news-carousel",
			autoplay: false,
			speed: 1000,
			items: 1,
			controlsPosition: "bottom",
			navPosition: "bottom",
			autoplayButtonOutput: false,
			controlsText: ["<span class='fas fa-angle-left'></span>", "<span class='fas fa-angle-right'></span>"]
		});

		if (slider) {
			slider.getInfo().prevButton.classList.add("tns-prev-button");
			slider.getInfo().nextButton.classList.add("tns-next-button");
			$(slider.getInfo().navContainer).wrap("<div class='tns-nav-wrapper'></div>");
		}
	}


	// *************************************************************************
	// Three in row carousel (comments on homepage, sponsors, ...)
	// *************************************************************************

	$(".carousel-three-in-row").each(function () {
		var $this = $(this);

		tns({
			container: $this.find(".carousel").get(0),
			items: 1,
			loop: false,
			gutter: 30,
			autoHeight: true,
			nav: false,
			controls: true,
			prevButton: $this.find(".carousel-prev").get(0),
			nextButton: $this.find(".carousel-next").get(0),
			responsive: {
				768: {
					items: 2
				},

				992: {
					items: 3
				}
			}
		});
	});

	// *************************************************************************
	// Gallery
	// *************************************************************************

	var $slider = $(".news-detail-photos");
	if ($slider.length) {
		tns({
			container: $slider.find(".carousel").get(0),
			autoWidth: true,
			loop: false,
			gutter: 15,
			nav: false,
			controls: true,
			prevButton: $slider.find(".carousel-prev").get(0),
			nextButton: $slider.find(".carousel-next").get(0),
		});
	}

	// *************************************************************************
	// Timeliners
	// *************************************************************************

	$(".timeliner").each(function () {
		var $timeliner = $(this);

		var slider = tns({
			container: $timeliner.find(".timeliner-body").get(0),
			autoplay: false,
			items: 1,
			controls: false,
			navContainer: $timeliner.find(".timeliner-navigation").get(0)
		});
	});


	// *************************************************************************
	// Actions
	// *************************************************************************

	//
	// Go through events using AJAX
	//
	$("body").on("click", "[data-action='events']", function (event) {
		event.preventDefault();
		var $this = $(this);
		$this.addClass("sending-request");
		var url = $this.attr("href");

		$.get(url).then(function (data) {
			$("#table-events").html(data);
		});

	});

});